/* Previous / next product navigation.
   Looks the current product up in its collection through the storefront /products.json endpoint,
   page by page, so it works for collections of any size (Liquid's paginate is capped at 250). */
(() => {
  const nav = document.querySelector('[data-product-nav]');
  if (!nav) return;

  const { collection, product } = nav.dataset;
  const prevLink = nav.querySelector('[data-product-nav-prev]');
  const nextLink = nav.querySelector('[data-product-nav-next]');
  const cacheKey = `product-nav:${collection}`;

  const readCache = () => {
    try {
      return JSON.parse(sessionStorage.getItem(cacheKey));
    } catch (e) {
      return null;
    }
  };

  const writeCache = (handles) => {
    try {
      sessionStorage.setItem(cacheKey, JSON.stringify(handles));
    } catch (e) {}
  };

  const fetchHandles = async () => {
    const handles = [];
    for (let page = 1; page <= 20; page++) {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}collections/${collection}/products.json?limit=250&page=${page}&fields=handle`);
      if (!response.ok) break;
      const { products } = await response.json();
      handles.push(...products.map((item) => item.handle));
      if (products.length < 250) break;
    }
    return handles;
  };

  const show = (link, handle) => {
    if (!handle) return;
    link.href = `${window.Shopify?.routes?.root || '/'}products/${handle}`;
    link.hidden = false;
  };

  (async () => {
    let handles = readCache();
    let index = handles ? handles.indexOf(product) : -1;

    // Cache missing or stale (e.g. newly created product): fetch fresh data.
    if (index === -1) {
      handles = await fetchHandles();
      index = handles.indexOf(product);
      if (index !== -1) writeCache(handles);
    }

    if (index === -1) return;

    show(prevLink, handles[index - 1]);
    show(nextLink, handles[index + 1]);
    nav.hidden = prevLink.hidden && nextLink.hidden;
  })().catch(() => {});
})();
